import { render, staticRenderFns } from "./MypageNavi.vue?vue&type=template&id=35de578e&scoped=true&"
import script from "./MypageNavi.vue?vue&type=script&lang=ts&"
export * from "./MypageNavi.vue?vue&type=script&lang=ts&"
import style0 from "./MypageNavi.vue?vue&type=style&index=0&id=35de578e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35de578e",
  null
  
)

export default component.exports